import React,{Component} from "react";
import {AllModules} from '@ag-grid-enterprise/all-modules';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme CSS
import 'ag-grid-enterprise';
import Constant from "../common/constants";
import redirectURL from '../redirectURL';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import $ from 'jquery'
import Switch from "react-switch";
import StackingConfiguration from './stackingConfiguration';
import ForecastingConfiguration from "./forecastingConfiguration";


export default class Configurations extends Component{
    constructor(props){
        super(props);
        this.state={
            show:false,
            basicTitle:"",
            basicType:"default",
            showAvailablityTable:false,
            dispatch:"activet",
            stacking : "",
            production : "",
            forecasting : "",
            resource : "",
            dispatchData:"show-m",
            stackingData:"show-n",
            productionData:"show-n",
            forecastingData:"show-n",
            resourceData:"show-n",
            dispatchChecked: false,
            dispatchInboundChecked: false,
            dispatchOutboundChecked: false,
            inbound_route_preferences_options:"show-n",
            inbound_route_configuration_type_options : "show-n",
            inbound_auto_clustering_type_options : "show-n",
            inbound_plant_wise_transporter_configuration_options : "show-n",
            inbound_plant_wise_freight_configuration_options : "show-n",
            inbound_plant_wise_freight_variable_cost_options : "show-n",
            inbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
            inbound_plant_wise_freight_configuration_type : "show-n",
            inbound_vehicle_availability_options : "show-n",
            inbound_vehicle_operational_times_options : "show-n",
            dispatchConfigs : "show-n",
            dispatchConfigsInbound : "show-n",
            dispatchConfigsOutbound : "show-n",
            outbound_route_preferences_options:"show-n",
            outbound_route_configuration_type_options : "show-n",
            outbound_auto_clustering_type_options : "show-n",
            outbound_plant_wise_transporter_configuration_options : "show-n",
            outbound_plant_wise_freight_configuration_options : "show-n",
            outbound_plant_wise_freight_variable_cost_options : "show-n",
            outbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
            outbound_plant_wise_freight_configuration_type : "show-n",
            outbound_vehicle_availability_options : "show-n",
            outbound_vehicle_operational_times_options : "show-n",
            dispatchShow:1,
            stackShow:1,
            productionPlanningShow:1,
            forecastingShow:1,
            resourceSchedulingShow:1,
        }
        
    }

    componentDidMount(){
        this.getConfigurations()
        let url_type = window.location.href
        if(url_type.includes("?") == true)
        {
            let path_type = url_type.split('?')
            let path = path_type[path_type.length-1]
            if(path == "dispatch_planning")
            {
                var dispatch = "activet";
                var stacking = "";
                var production = "";
                var forecasting = "";
                var resource = "";
                var dispatchData = "show-m";
                var stackingData = "show-n";
                var productionData = "show-n";
                var forecastingData = "show-n";
                var resourceData = "show-n";
                this.setState({
                    dispatchShow:1,
                    stackShow:0,
                    productionPlanningShow:0,
                    forecastingShow:0,
                    resourceSchedulingShow:0,
                });
            }
            else if(path == "stacking")
            {
                var dispatch = "";
                var stacking = "activet";
                var production = "";
                var forecasting = "";
                var resource = "";
                var dispatchData = "show-n";
                var stackingData = "show-m";
                var productionData = "show-n";
                var forecastingData = "show-n";
                var resourceData = "show-n";
                this.setState({
                    dispatchShow:0,
                    stackShow:1,
                    productionPlanningShow:0,
                    forecastingShow:0,
                    resourceSchedulingShow:0,
                });

            }
            else if(path == "forecasting")
            {
                var dispatch = "";
                var stacking = "";
                var production = "";
                var forecasting = "activet";
                var resource = "";
                var dispatchData = "show-n";
                var stackingData = "show-n";
                var productionData = "show-n";
                var forecastingData = "show-m";
                var resourceData = "show-n";
                this.setState({
                    dispatchShow:0,
                    stackShow:0,
                    productionPlanningShow:0,
                    forecastingShow:1,
                    resourceSchedulingShow:0,
                });
            }
            else
            {
                var dispatch = "activet";
                var stacking = "";
                var production = "";
                var forecasting = "";
                var resource = "";
                var dispatchData = "show-m";
                var stackingData = "show-n";
                var productionData = "show-n";
                var forecastingData = "show-n";
                var resourceData = "show-n";
                this.setState({
                    dispatchShow:1,
                    stackShow:1,
                    productionPlanningShow:1,
                    forecastingShow:1,
                    resourceSchedulingShow:1,
                });
            }
            this.setState({
                dispatch:dispatch,
                stacking:stacking,
                production:production,
                forecasting:forecasting,
                resource:resource,
                dispatchData:dispatchData,
                stackingData:stackingData,
                productionData:productionData,
                forecastingData:forecastingData,
                resourceData:resourceData,
            })
        }
    }

    getConfigurations = () =>{
        redirectURL.post('master/getConfigurations')
        .then(async response =>{
            var dispatchConfigs = "show-n";
            var dispatchChecked = false;
            var dispatchInboundChecked = false;
            var dispatchOutboundChecked = false;
            var dispatchConfigsInbound = "show-n";
            var dispatchConfigsOutbound = "show-n";
            var inbound_vehicle_operational_times_options = "show-n";
            var inbound_plant_wise_freight_configuration_options = "show-n";
            var inbound_plant_wise_freight_variable_cost_options = "show-n";
            var inbound_plant_wise_freight_city_level_vehicle_cost_options = "show-n";
            var inbound_plant_wise_transporter_configuration_options = "show-n";
            var inbound_vehicle_availability_options = "show-n";
            var inbound_route_preferences_options = "show-n";
            var inbound_route_configuration_type_options = "show-n";
            var inbound_auto_clustering_type_options = "show-n";
            var outbound_vehicle_operational_times_options = "show-n";
            var outbound_vehicle_availability_options = "show-n";
            var outbound_plant_wise_freight_configuration_options = "show-n";
            var outbound_plant_wise_freight_variable_cost_options = "show-n";
            var outbound_plant_wise_freight_city_level_vehicle_cost_options = "show-n";
            var outbound_plant_wise_transporter_configuration_options = "show-n";
            var outbound_route_preferences_options = "show-n";
            var outbound_route_configuration_type_options = "show-n";
            var outbound_auto_clustering_type_options = "show-n";
            var configData = response.data;
            if(configData.length > 0)
            {
                var dispatchInBound = await configData.filter((cd) => cd.module_type == 1 && cd.data_type == 1);
                if(dispatchInBound.length > 0)
                {
                    dispatchChecked = true;
                    dispatchConfigs = "";
                    dispatchInboundChecked = true;
                    dispatchConfigsInbound = "";
                    if(dispatchInBound[0].pickup == 1)
                    {
                        $("#inbound_pickup").prop('checked',true)
                    }
                    if(dispatchInBound[0].drop == 1)
                    {
                        $("#inbound_drop").prop('checked',true)
                    }
                    if(dispatchInBound[0].pickup_time_windows == 1)
                    {
                        $("#inbound_pickup_time_windows").prop('checked',true)
                    }
                    if(dispatchInBound[0].drop_time_windows == 1)
                    {
                        $("#inbound_drop_time_windows").prop('checked',true)
                    }
                    if(dispatchInBound[0].vehicle_types == 1)
                    {
                        $("#inbound_vehicle_types").prop('checked',true)
                    }
                    if(dispatchInBound[0].max_no_of_trucks !=undefined && dispatchInBound[0].max_no_of_trucks !="")
                    {
                        $("#max_no_of_trucks").val(dispatchInBound[0].max_no_of_trucks)
                    }
                    if(dispatchInBound[0].truck_min_max_configuration_preferences == 1)
                    {
                        $("#inbound_truck_min_max_configuration_preferences").prop('checked',true)
                    }
                    if(dispatchInBound[0].truck_weight_min_max_preferences == 1)
                    {
                        $("#inbound_truck_weight_min_max_preferences").prop('checked',true)
                    }
                    if(dispatchInBound[0].min_load_preferences == 1)
                    {
                        $("#inbound_min_load_preferences").prop('checked',true)
                    }
                    if(dispatchInBound[0].clubbing_limits == 1)
                    {
                        $("#inbound_clubbing_limits").prop('checked',true)
                    }
                    if(dispatchInBound[0].distance_preferences == 1)
                    {
                        $("#inbound_distance_preferences").prop('checked',true)
                    }
                    if(dispatchInBound[0].truck_priorities == 1)
                    {
                        $("#inbound_truck_priorities").prop('checked',true)
                    }
                    if(dispatchInBound[0].vehicle_operational_times == 1)
                    {
                        inbound_vehicle_operational_times_options = "show-m";
                        $("#inbound_vehicle_operational_times").prop('checked',true)
                        if(dispatchInBound[0].vehicle_operational_times_type == 1)
                        {
                            $("#inbound_generic_time_windows").prop('checked',true)
                            $("#inbound_vehicle_availability").prop('disabled', false);
                            $("#inbound_vehicle_availability_by_vehicle_type").prop('disabled', false);
                        }
                        if(dispatchInBound[0].vehicle_operational_times_type == 2)
                        {
                            $("#inbound_individual_truck_time_windows").prop('checked',true)
                            $("#inbound_vehicle_availability").prop('disabled', true);
                            $("#inbound_vehicle_availability_by_vehicle_type").prop('disabled', true);
                        }
                    }
                    if(dispatchInBound[0].vehicle_availability == 1)
                    {
                        inbound_vehicle_availability_options = "show-m";
                        $("#inbound_vehicle_availability").prop('checked',true)
                        if(dispatchInBound[0].vehicle_availability_type == 1)
                        {
                            $("#inbound_vehicle_availability_by_vehicle_type").prop('checked',true)
                        }
                        if(dispatchInBound[0].vehicle_availability_type == 2)
                        {
                            $("#inbound_vehicle_availability_by_individual_vehicle").prop('checked',true)
                        }
                    }
                    if(dispatchInBound[0].loading_unloading_sequencing == 1)
                    {
                        $("#inbound_loading_unloading_sequencing").prop('checked',true)
                    }
                    if(dispatchInBound[0].material_configuration == 1)
                    {
                        $("#inbound_material_configuration").prop('checked',true)
                    }
                    if(dispatchInBound[0].plant_wise_freight_configuration == 1)
                    {
                        inbound_plant_wise_freight_configuration_options = "show-m";
                        $("#inbound_plant_wise_freight_configuration").prop('checked',true)
                        if(dispatchInBound[0].plant_wise_freight_fixed_cost == 1)
                        {
                            $("#inbound_plant_wise_freight_fixed_cost").prop('checked',true)
                        }
                        if(dispatchInBound[0].plant_wise_freight_variable_cost == 1)
                        {
                            inbound_plant_wise_freight_variable_cost_options = "show-m";
                            $("#inbound_plant_wise_freight_variable_cost").prop('checked',true)
                        }
                        if(dispatchInBound[0].plant_wise_freight_vehicle_type_variable_cost == 1)
                        {
                            $("#inbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked',true)
                        }
                        if(dispatchInBound[0].plant_wise_freight_city_level_vehicle_cost == 1)
                        {
                            inbound_plant_wise_freight_city_level_vehicle_cost_options = "show-m";
                            $("#inbound_plant_wise_freight_city_level_vehicle_cost").prop('checked',true)
                            if(dispatchInBound[0].per_cmt_cost == 1)
                            {
                                $("#inbound_per_cmt_cost").prop('checked',true)
                            }
                            if(dispatchInBound[0].per_km_cost == 2)
                            {
                                $("#inbound_per_km_cost").prop('checked',true)
                            }                            
                        }
                    }
                    if(dispatchInBound[0].plant_wise_transporter_configuration == 1)
                    {
                        inbound_plant_wise_transporter_configuration_options = "show-m";
                        $("#inbound_plant_wise_transporter_configuration").prop('checked',true)
                        if(dispatchInBound[0].transporter_share_of_business == 1)
                        {
                            $("#inbound_transporter_share_of_business").prop('checked',true)
                        }
                    }
                    if(dispatchInBound[0].route_preferences == 1)
                    {
                        inbound_route_preferences_options = "show-m";
                        $("#inbound_route_preferences").prop('checked',true)
                        if(dispatchInBound[0].route_configuration == 1)
                        {
                            inbound_route_configuration_type_options = "show-m";
                            $("#inbound_route_configuration").prop('checked',true)
                            if(dispatchInBound[0].route_configuration_type == 1)
                            {
                                $("#inbound_plant_wise_configuration").prop('checked',true)
                            }
                            if(dispatchInBound[0].route_configuration_type == 2)
                            {
                                $("#inbound_zone_wise_configuration").prop('checked',true)
                            }
                            if(dispatchInBound[0].route_configuration_type == 3)
                            {
                                $("#inbound_transporter_wise_configuration").prop('checked',true)
                            }
                        }
                        if(dispatchInBound[0].auto_clustering == 2)
                        {
                            inbound_auto_clustering_type_options = "show-m";
                            $("#inbound_auto_clustering").prop('checked',true)
                            if(dispatchInBound[0].auto_clustering_type == 1)
                            {
                                $("#inbound_cluster_based_on_proximite").prop('checked',true)
                            }
                            if(dispatchInBound[0].auto_clustering_type == 2)
                            {
                                $("#inbound_cluster_based_on_demands").prop('checked',true)
                            }
                            if(dispatchInBound[0].auto_clustering_type == 3)
                            {
                                $("#inbound_cluster_based_on_demand_distance_factor").prop('checked',true)
                            }
                        }
                    }
                    if(dispatchInBound[0].plant_wise_new_plan_creation == 1)
                    {
                        $("#inbound_plant_wise_new_plan_creation").prop('checked',true)
                    }
                    if(dispatchInBound[0].plant_wise_plan_summary == 1)
                    {
                        $("#inbound_plant_wise_plan_summary").prop('checked',true)
                    }
                    if(dispatchInBound[0].plant_wise_planning_history == 1)
                    {
                        $("#inbound_plant_wise_planning_history").prop('checked',true)
                    }
                }
                var dispatchOutBound = await configData.filter((cd) => cd.module_type == 1 && cd.data_type == 2);
                if(dispatchOutBound.length > 0)
                {
                    dispatchChecked = true;
                    dispatchConfigs = "";
                    dispatchOutboundChecked = true;
                    dispatchConfigsOutbound = "";
                    if(dispatchOutBound[0].pickup == 1)
                    {
                        $("#outbound_pickup").prop('checked',true)
                    }
                    if(dispatchOutBound[0].drop == 1)
                    {
                        $("#outbound_drop").prop('checked',true)
                    }
                    if(dispatchOutBound[0].pickup_time_windows == 1)
                    {
                        $("#outbound_pickup_time_windows").prop('checked',true)
                    }
                    if(dispatchOutBound[0].drop_time_windows == 1)
                    {
                        $("#outbound_drop_time_windows").prop('checked',true)
                    }
                    if(dispatchOutBound[0].vehicle_types == 1)
                    {
                        $("#outbound_vehicle_types").prop('checked',true)
                    }
                    if(dispatchOutBound[0].max_no_of_trucks !=undefined && dispatchOutBound[0].max_no_of_trucks !="")
                    {
                        $("#max_no_of_trucks").val(dispatchOutBound[0].max_no_of_trucks)
                    }
                    if(dispatchOutBound[0].truck_min_max_configuration_preferences == 1)
                    {
                        $("#outbound_truck_min_max_configuration_preferences").prop('checked',true)
                    }
                    if(dispatchOutBound[0].truck_weight_min_max_preferences == 1)
                    {
                        $("#outbound_truck_weight_min_max_preferences").prop('checked',true)
                    }
                    if(dispatchOutBound[0].min_load_preferences == 1)
                    {
                        $("#outbound_min_load_preferences").prop('checked',true)
                    }
                    if(dispatchOutBound[0].clubbing_limits == 1)
                    {
                        $("#outbound_clubbing_limits").prop('checked',true)
                    }
                    if(dispatchOutBound[0].distance_preferences == 1)
                    {
                        $("#outbound_distance_preferences").prop('checked',true)
                    }
                    if(dispatchOutBound[0].truck_priorities == 1)
                    {
                        $("#outbound_truck_priorities").prop('checked',true)
                    }
                    if(dispatchOutBound[0].vehicle_operational_times == 1)
                    {
                        outbound_vehicle_operational_times_options = "show-m";
                        $("#outbound_vehicle_operational_times").prop('checked',true)
                        if(dispatchOutBound[0].vehicle_operational_times_type == 1)
                        {
                            $("#outbound_generic_time_windows").prop('checked',true)
                            $("#outbound_vehicle_availability").prop('disabled', false);
                            $("#outbound_vehicle_availability_by_vehicle_type").prop('disabled', false);
                        }
                        if(dispatchOutBound[0].vehicle_operational_times_type == 2)
                        {
                            $("#outbound_individual_truck_time_windows").prop('checked',true)
                            $("#outbound_vehicle_availability").prop('disabled', true);
                            $("#outbound_vehicle_availability_by_vehicle_type").prop('disabled', true);
                        }
                    }
                    if(dispatchOutBound[0].vehicle_availability == 1)
                    {
                        outbound_vehicle_availability_options = "show-m"
                        $("#outbound_vehicle_availability").prop('checked',true)
                        if(dispatchOutBound[0].vehicle_availability_type == 1)
                        {
                            $("#outbound_vehicle_availability_by_vehicle_type").prop('checked',true)
                        }
                        if(dispatchOutBound[0].vehicle_availability_type == 2)
                        {
                            $("#outbound_vehicle_availability_by_individual_vehicle").prop('checked',true)
                        }
                    }
                    if(dispatchOutBound[0].loading_unloading_sequencing == 1)
                    {
                        $("#outbound_loading_unloading_sequencing").prop('checked',true)
                    }
                    if(dispatchOutBound[0].material_configuration == 1)
                    {
                        $("#outbound_material_configuration").prop('checked',true)
                    }
                    if(dispatchOutBound[0].plant_wise_freight_configuration == 1)
                    {
                        outbound_plant_wise_freight_configuration_options = "show-m";
                        $("#outbound_plant_wise_freight_configuration").prop('checked',true)
                        if(dispatchOutBound[0].plant_wise_freight_fixed_cost == 1)
                        {
                            $("#outbound_plant_wise_freight_fixed_cost").prop('checked',true)
                        }
                        if(dispatchOutBound[0].plant_wise_freight_variable_cost == 1)
                        {
                            outbound_plant_wise_freight_variable_cost_options = "show-m";
                            $("#outbound_plant_wise_freight_variable_cost").prop('checked',true)
                        }
                        if(dispatchOutBound[0].plant_wise_freight_vehicle_type_variable_cost == 1)
                        {
                            $("#outbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked',true)
                        }
                        if(dispatchOutBound[0].plant_wise_freight_city_level_vehicle_cost == 1)
                        {
                            outbound_plant_wise_freight_city_level_vehicle_cost_options = "show-m";
                            $("#outbound_plant_wise_freight_city_level_vehicle_cost").prop('checked',true)
                            if(dispatchOutBound[0].per_cmt_cost == 1)
                            {
                                $("#outbound_per_cmt_cost").prop('checked',true)
                            }
                            if(dispatchOutBound[0].per_km_cost == 2)
                            {
                                $("#outbound_per_km_cost").prop('checked',true)
                            }                            
                        }
                    }
                    if(dispatchOutBound[0].plant_wise_transporter_configuration == 1)
                    {
                        outbound_plant_wise_transporter_configuration_options = "show-m";
                        $("#outbound_plant_wise_transporter_configuration").prop('checked',true)
                        if(dispatchOutBound[0].transporter_share_of_business == 1)
                        {
                            $("#outbound_transporter_share_of_business").prop('checked',true)
                        }
                    }
                    if(dispatchOutBound[0].route_preferences == 1)
                    {
                        outbound_route_preferences_options = "show-m";
                        $("#outbound_route_preferences").prop('checked',true)
                        if(dispatchOutBound[0].route_configuration == 1)
                        {
                            outbound_route_configuration_type_options = "show-m";
                            $("#outbound_route_configuration").prop('checked',true)
                            if(dispatchOutBound[0].route_configuration_type == 1)
                            {
                                $("#outbound_plant_wise_configuration").prop('checked',true)
                            }
                            if(dispatchOutBound[0].route_configuration_type == 2)
                            {
                                $("#outbound_zone_wise_configuration").prop('checked',true)
                            }
                            if(dispatchOutBound[0].route_configuration_type == 3)
                            {
                                $("#outbound_transporter_wise_configuration").prop('checked',true)
                            }
                        }
                        if(dispatchOutBound[0].auto_clustering == 2)
                        {
                            outbound_auto_clustering_type_options = "show-m";
                            $("#outbound_auto_clustering").prop('checked',true)
                            if(dispatchOutBound[0].auto_clustering_type == 1)
                            {
                                $("#outbound_cluster_based_on_proximite").prop('checked',true)
                            }
                            if(dispatchOutBound[0].auto_clustering_type == 2)
                            {
                                $("#outbound_cluster_based_on_demands").prop('checked',true)
                            }
                            if(dispatchOutBound[0].auto_clustering_type == 3)
                            {
                                $("#outbound_cluster_based_on_demand_distance_factor").prop('checked',true)
                            }
                        }
                    }
                    if(dispatchOutBound[0].plant_wise_new_plan_creation == 1)
                    {
                        $("#outbound_plant_wise_new_plan_creation").prop('checked',true)
                    }
                    if(dispatchOutBound[0].plant_wise_plan_summary == 1)
                    {
                        $("#outbound_plant_wise_plan_summary").prop('checked',true)
                    }
                    if(dispatchOutBound[0].plant_wise_planning_history == 1)
                    {
                        $("#outbound_plant_wise_planning_history").prop('checked',true)
                    }
                    
                }
            }
            this.setState({
                dispatchChecked:dispatchChecked,
                dispatchConfigs:dispatchConfigs,
                dispatchInboundChecked:dispatchInboundChecked,
                dispatchConfigsInbound:dispatchConfigsInbound,
                inbound_vehicle_operational_times_options:inbound_vehicle_operational_times_options,
                inbound_vehicle_availability_options:inbound_vehicle_availability_options,
                inbound_plant_wise_freight_configuration_options:inbound_plant_wise_freight_configuration_options,
                inbound_plant_wise_freight_variable_cost_options:inbound_plant_wise_freight_variable_cost_options,
                inbound_plant_wise_freight_city_level_vehicle_cost_options:inbound_plant_wise_freight_city_level_vehicle_cost_options,
                inbound_plant_wise_transporter_configuration_options:inbound_plant_wise_transporter_configuration_options,
                inbound_route_preferences_options:inbound_route_preferences_options,
                inbound_route_configuration_type_options:inbound_route_configuration_type_options,
                inbound_auto_clustering_type_options:inbound_auto_clustering_type_options,
                dispatchOutboundChecked:dispatchOutboundChecked,
                dispatchConfigsOutbound:dispatchConfigsOutbound,
                outbound_vehicle_operational_times_options:outbound_vehicle_operational_times_options,
                outbound_vehicle_availability_options:outbound_vehicle_availability_options,
                outbound_plant_wise_freight_configuration_options:outbound_plant_wise_freight_configuration_options,
                outbound_plant_wise_freight_variable_cost_options:outbound_plant_wise_freight_variable_cost_options,
                outbound_plant_wise_freight_city_level_vehicle_cost_options:outbound_plant_wise_freight_city_level_vehicle_cost_options,
                outbound_plant_wise_transporter_configuration_options:outbound_plant_wise_transporter_configuration_options,
                outbound_route_preferences_options:outbound_route_preferences_options,
                outbound_route_configuration_type_options:outbound_route_configuration_type_options,
                outbound_auto_clustering_type_options:outbound_auto_clustering_type_options,
            })
        })
    }
    onClickTab = (pageType) => {
        if(pageType == "dispatch")
        {
            var dispatch = "activet";
            var stacking = "";
            var production = "";
            var forecasting = "";
            var resource = "";
            var dispatchData = "show-m";
            var stackingData = "show-n";
            var productionData = "show-n";
            var forecastingData = "show-n";
            var resourceData = "show-n";
        }
        else if(pageType == "stacking")
        {
            var dispatch = "";
            var stacking = "activet";
            var production = "";
            var forecasting = "";
            var resource = "";
            var dispatchData = "show-n";
            var stackingData = "show-m";
            var productionData = "show-n";
            var forecastingData = "show-n";
            var resourceData = "show-n";
        }
        else if(pageType == "production")
        {
            var dispatch = "";
            var stacking = "";
            var production = "activet";
            var forecasting = "";
            var resource = "";
            var dispatchData = "show-n";
            var stackingData = "show-n";
            var productionData = "show-m";
            var forecastingData = "show-n";
            var resourceData = "show-n";
        }
        else if(pageType == "forecasting")
        {
            var dispatch = "";
            var stacking = "";
            var production = "";
            var forecasting = "activet";
            var resource = "";
            var dispatchData = "show-n";
            var stackingData = "show-n";
            var productionData = "show-n";
            var forecastingData = "show-m";
            var resourceData = "show-n";
        }
        else if(pageType == "resource")
        {
            var dispatch = "";
            var stacking = "";
            var production = "";
            var forecasting = "";
            var resource = "activet";
            var dispatchData = "show-n";
            var stackingData = "show-n";
            var productionData = "show-n";
            var forecastingData = "show-n";
            var resourceData = "show-m";
        }
        this.setState({
            dispatch:dispatch,
            stacking:stacking,
            production:production,
            forecasting:forecasting,
            resource:resource,
            dispatchData:dispatchData,
            stackingData:stackingData,
            productionData:productionData,
            forecastingData:forecastingData,
            resourceData:resourceData,
        })
    }
    handleDispatchChange = (checked) => {
        var dispatchConfigs = "show-n";
        if(checked == true)
        {
            dispatchConfigs = "";
        }
        this.setState({ dispatchChecked : checked, dispatchConfigs:dispatchConfigs});
    }
    handleDispatchInboundChange = (checked) => {
        var dispatchConfigsInbound = "show-n";
        if(checked == true)
        {
            dispatchConfigsInbound = "";
        }
        this.setState({ dispatchInboundChecked : checked, dispatchConfigsInbound:dispatchConfigsInbound});
    }
    handleDispatchOutboundChange = (checked) => {
        var dispatchConfigsOutbound = "show-n";
        if(checked == true)
        {
            dispatchConfigsOutbound = "";
        }
        this.setState({ dispatchOutboundChecked : checked, dispatchConfigsOutbound:dispatchConfigsOutbound});
    }
    changeHandler = (e) => {
        if(e.target.name == "inbound_max_no_of_trucks_check")
        {
            if(e.target.checked == true)
            {
                $("#inbound_max_no_of_trucks").removeAttr('disabled', true);
            }
            else
            {
                $("#inbound_max_no_of_trucks").val(4);
                $("#inbound_max_no_of_trucks").attr('disabled', true);
            }          
        }
        if(e.target.name == "inbound_vehicle_operational_times")
        {
            if(e.target.checked == true)
            {
               var inbound_vehicle_operational_times_options = "show-m";
            }
            else
            {
                var inbound_vehicle_operational_times_options = "show-n";
                $("#inbound_generic_time_windows").prop('checked', false);
                $("#inbound_individual_truck_time_windows").prop('checked', false);
                $("#inbound_vehicle_availability").prop('disabled', false);
                $("#inbound_vehicle_availability_by_vehicle_type").prop('disabled', false);
            }
            this.setState({
                inbound_vehicle_operational_times_options : inbound_vehicle_operational_times_options
            });            
        }
        if(e.target.name == "inbound_vehicle_operational_times_type")
        {
            if(e.target.checked == true)
            {
                if(e.target.value == 2)
                {
                    var inbound_vehicle_availability_options = "show-m";
                    $("#inbound_vehicle_availability").prop('checked', true);
                    $("#inbound_vehicle_availability_by_individual_vehicle").prop('checked', true);
                    $("#inbound_vehicle_availability").prop('disabled', true);
                    $("#inbound_vehicle_availability_by_vehicle_type").prop('disabled', true);
                }
                else
                {
                    var inbound_vehicle_availability_options = "show-n";
                    $("#inbound_vehicle_availability").prop('checked', false);
                    $("#inbound_vehicle_availability_by_individual_vehicle").prop('checked', false);
                    $("#inbound_vehicle_availability").prop('disabled', false);
                    $("#inbound_vehicle_availability_by_vehicle_type").prop('disabled', false);
                }
                this.setState({
                    inbound_vehicle_availability_options : inbound_vehicle_availability_options
                });
            }          
        }
        if(e.target.name == "inbound_vehicle_availability")
        {
            if(e.target.checked == true)
            {
               var inbound_vehicle_availability_options = "show-m";
            }
            else
            {
                var inbound_vehicle_availability_options = "show-n";
                $("#inbound_vehicle_availability_by_vehicle_type").prop('checked', false);
                $("#inbound_vehicle_availability_by_individual_vehicle").prop('checked', false);
            }
            this.setState({
                inbound_vehicle_availability_options : inbound_vehicle_availability_options
            });
        }
        if(e.target.name == "inbound_plant_wise_freight_configuration")
        {
            if(e.target.checked == true)
            {
               var inbound_plant_wise_freight_configuration_options = "show-m";
            }
            else
            {
                var inbound_plant_wise_freight_configuration_options = "show-n";
                $("#inbound_plant_wise_freight_fixed_cost").prop('checked', false);
                $("#inbound_plant_wise_freight_variable_cost").prop('checked', false);
                $("#inbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked', false);
                $("#inbound_plant_wise_freight_city_level_vehicle_cost").prop('checked', false);
                $("#inbound_per_cmt_cost").prop('checked', false);
                $("#inbound_per_km_cost").prop('checked', false);
                this.setState({
                    inbound_plant_wise_freight_configuration_type : "show-n",
                    inbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
                });
            }
            this.setState({
                inbound_plant_wise_freight_configuration_options : inbound_plant_wise_freight_configuration_options
            });
        }
        if(e.target.name == "inbound_plant_wise_freight_variable_cost")
        {
            var inbound_plant_wise_freight_variable_cost_options = "show-n";
            if(e.target.checked == true)
            {
                if(e.target.value == 1)
                {
                    var inbound_plant_wise_freight_variable_cost_options = "show-m";
                }
                else
                {
                    $("#inbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked', false);
                    $("#inbound_plant_wise_freight_city_level_vehicle_cost").prop('checked', false);
                    $("#inbound_per_cmt_cost").prop('checked', false);
                    $("#inbound_per_km_cost").prop('checked', false);
                    this.setState({
                        inbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
                    });
                }
            }
            else
            {
                $("#inbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked', false);
                $("#inbound_plant_wise_freight_city_level_vehicle_cost").prop('checked', false);
                $("#inbound_per_cmt_cost").prop('checked', false);
                $("#inbound_per_km_cost").prop('checked', false);
                this.setState({
                    inbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
                });
            }
            this.setState({
                inbound_plant_wise_freight_variable_cost_options : inbound_plant_wise_freight_variable_cost_options,
            });
        }
        
        if(e.target.name == "inbound_plant_wise_freight_city_level_vehicle_cost")
        {
            var inbound_plant_wise_freight_city_level_vehicle_cost_options = "show-n";
            if(e.target.checked == true)
            {
                if(e.target.value == 1)
                {
                    var inbound_plant_wise_freight_city_level_vehicle_cost_options = "show-m";
                }
                else
                {
                    $("#inbound_per_cmt_cost").prop('checked', false);
                    $("#inbound_per_km_cost").prop('checked', false);
                }
            }
            else
            {
                $("#inbound_per_cmt_cost").prop('checked', false);
                $("#inbound_per_km_cost").prop('checked', false);
            }
            this.setState({
                inbound_plant_wise_freight_city_level_vehicle_cost_options : inbound_plant_wise_freight_city_level_vehicle_cost_options,
            });
        }
        if(e.target.name == "inbound_plant_wise_transporter_configuration")
        {
            if(e.target.checked == true)
            {
               var inbound_plant_wise_transporter_configuration_options = "show-m";
            }
            else
            {
                var inbound_plant_wise_transporter_configuration_options = "show-n";
                $("#inbound_transporter_share_of_business").prop('checked', false);
            }
            this.setState({
                inbound_plant_wise_transporter_configuration_options : inbound_plant_wise_transporter_configuration_options
            });
        }
        if(e.target.name == "inbound_route_preferences")
        {
            if(e.target.checked == true)
            {
               var inbound_route_preferences_options = "show-m";
            }
            else
            {
                var inbound_route_preferences_options = "show-n";
                $("#inbound_route_configuration").prop('checked', false);
                $("#inbound_auto_clustering").prop('checked', false);
                $("#inbound_plant_wise_configuration").prop('checked', false);
                $("#inbound_zone_wise_configuration").prop('checked', false);
                $("#inbound_transporter_wise_configuration").prop('checked', false);
                $("#inbound_cluster_based_on_proximite").prop('checked', false);
                $("#inbound_cluster_based_on_demands").prop('checked', false);
                $("#inbound_cluster_based_on_demand_distance_factor").prop('checked', false);
                this.setState({
                    inbound_route_configuration_type_options : "show-n",
                    inbound_auto_clustering_type_options : "show-n",
                });
            }
            this.setState({
                inbound_route_preferences_options : inbound_route_preferences_options
            });
        }
        if(e.target.name == "inbound_route_configuration")
        {
            var inbound_route_configuration_type_options = "show-n";
            var inbound_auto_clustering_type_options = "show-n";
            if(e.target.checked == true)
            {
                if(e.target.value == 1)
                {
                    var inbound_route_configuration_type_options = "show-m";
                }
                else
                {                    
                    $("#inbound_cluster_based_on_proximite").prop('checked', false);
                    $("#inbound_cluster_based_on_demands").prop('checked', false);
                    $("#inbound_cluster_based_on_demand_distance_factor").prop('checked', false);
                }
                if(e.target.value == 2)
                {
                    var inbound_auto_clustering_type_options = "show-m";
                }
                else
                {
                    $("#inbound_plant_wise_configuration").prop('checked', false);
                    $("#inbound_zone_wise_configuration").prop('checked', false);
                    $("#inbound_transporter_wise_configuration").prop('checked', false);
                }
            }
            else
            {
                $("#inbound_plant_wise_configuration").prop('checked', false);
                $("#inbound_zone_wise_configuration").prop('checked', false);
                $("#inbound_transporter_wise_configuration").prop('checked', false);
                $("#inbound_cluster_based_on_proximite").prop('checked', false);
                $("#inbound_cluster_based_on_demands").prop('checked', false);
                $("#inbound_cluster_based_on_demand_distance_factor").prop('checked', false);
            }
            this.setState({
                inbound_route_configuration_type_options : inbound_route_configuration_type_options,
                inbound_auto_clustering_type_options : inbound_auto_clustering_type_options,
            });
        }
        if(e.target.name == "outbound_max_no_of_trucks_check")
        {
            if(e.target.checked == true)
            {
                $("#outbound_max_no_of_trucks").removeAttr('disabled', true);
            }
            else
            {
                $("#outbound_max_no_of_trucks").val(4);
                $("#outbound_max_no_of_trucks").attr('disabled', true);
            }          
        }
        if(e.target.name == "outbound_vehicle_operational_times")
        {
            if(e.target.checked == true)
            {
               var outbound_vehicle_operational_times_options = "show-m";
            }
            else
            {
                var outbound_vehicle_operational_times_options = "show-n";
                $("#outbound_generic_time_windows").prop('checked', false);
                $("#outbound_individual_truck_time_windows").prop('checked', false);
                $("#outbound_vehicle_availability").prop('disabled', false);
                $("#outbound_vehicle_availability_by_vehicle_type").prop('disabled', false);
            }
            this.setState({
                outbound_vehicle_operational_times_options : outbound_vehicle_operational_times_options
            });            
        }
        if(e.target.name == "outbound_vehicle_operational_times_type")
        {
            if(e.target.checked == true)
            {
                if(e.target.value == 2)
                {
                    var outbound_vehicle_availability_options = "show-m";
                    $("#outbound_vehicle_availability").prop('checked', true);
                    $("#outbound_vehicle_availability_by_individual_vehicle").prop('checked', true);
                    $("#outbound_vehicle_availability").prop('disabled', true);
                    $("#outbound_vehicle_availability_by_vehicle_type").prop('disabled', true);
                }
                else
                {
                    var outbound_vehicle_availability_options = "show-n";
                    $("#outbound_vehicle_availability").prop('checked', false);
                    $("#outbound_vehicle_availability_by_individual_vehicle").prop('checked', false);
                    $("#outbound_vehicle_availability").prop('disabled', false);
                    $("#outbound_vehicle_availability_by_vehicle_type").prop('disabled', false);
                }
                this.setState({
                    outbound_vehicle_availability_options : outbound_vehicle_availability_options
                });
            }          
        }
        if(e.target.name == "outbound_vehicle_availability")
        {
            if(e.target.checked == true)
            {
               var outbound_vehicle_availability_options = "show-m";
            }
            else
            {
                var outbound_vehicle_availability_options = "show-n";
                $("#outbound_vehicle_availability_by_vehicle_type").prop('checked', false);
                $("#outbound_vehicle_availability_by_individual_vehicle").prop('checked', false);
            }
            this.setState({
                outbound_vehicle_availability_options : outbound_vehicle_availability_options
            });
        }
        if(e.target.name == "outbound_plant_wise_freight_configuration")
        {
            if(e.target.checked == true)
            {
               var outbound_plant_wise_freight_configuration_options = "show-m";
            }
            else
            {
                var outbound_plant_wise_freight_configuration_options = "show-n";
                $("#outbound_plant_wise_freight_fixed_cost").prop('checked', false);
                $("#outbound_plant_wise_freight_variable_cost").prop('checked', false);
                $("#outbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked', false);
                $("#outbound_plant_wise_freight_city_level_vehicle_cost").prop('checked', false);
                $("#outbound_per_cmt_cost").prop('checked', false);
                $("#outbound_per_km_cost").prop('checked', false);
                this.setState({
                    outbound_plant_wise_freight_configuration_type : "show-n",
                    outbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
                });
            }
            this.setState({
                outbound_plant_wise_freight_configuration_options : outbound_plant_wise_freight_configuration_options
            });
        }
        if(e.target.name == "outbound_plant_wise_freight_variable_cost")
        {
            var outbound_plant_wise_freight_variable_cost_options = "show-n";
            if(e.target.checked == true)
            {
                if(e.target.value == 1)
                {
                    var outbound_plant_wise_freight_variable_cost_options = "show-m";
                }
                else
                {
                    $("#outbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked', false);
                    $("#outbound_plant_wise_freight_city_level_vehicle_cost").prop('checked', false);
                    $("#outbound_per_cmt_cost").prop('checked', false);
                    $("#outbound_per_km_cost").prop('checked', false);
                    this.setState({
                        outbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
                    });
                }
            }
            else
            {
                $("#outbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked', false);
                $("#outbound_plant_wise_freight_city_level_vehicle_cost").prop('checked', false);
                $("#outbound_per_cmt_cost").prop('checked', false);
                $("#outbound_per_km_cost").prop('checked', false);
                this.setState({
                    outbound_plant_wise_freight_city_level_vehicle_cost_options : "show-n",
                });
            }
            this.setState({
                outbound_plant_wise_freight_variable_cost_options : outbound_plant_wise_freight_variable_cost_options,
            });
        }
        
        if(e.target.name == "outbound_plant_wise_freight_city_level_vehicle_cost")
        {
            var outbound_plant_wise_freight_city_level_vehicle_cost_options = "show-n";
            if(e.target.checked == true)
            {
                if(e.target.value == 1)
                {
                    var outbound_plant_wise_freight_city_level_vehicle_cost_options = "show-m";
                }
                else
                {
                    $("#outbound_per_cmt_cost").prop('checked', false);
                    $("#outbound_per_km_cost").prop('checked', false);
                }
            }
            else
            {
                $("#outbound_per_cmt_cost").prop('checked', false);
                $("#outbound_per_km_cost").prop('checked', false);
            }
            this.setState({
                outbound_plant_wise_freight_city_level_vehicle_cost_options : outbound_plant_wise_freight_city_level_vehicle_cost_options,
            });
        }
        if(e.target.name == "outbound_plant_wise_transporter_configuration")
        {
            if(e.target.checked == true)
            {
               var outbound_plant_wise_transporter_configuration_options = "show-m";
            }
            else
            {
                var outbound_plant_wise_transporter_configuration_options = "show-n";
                $("#outbound_transporter_share_of_business").prop('checked', false);
            }
            this.setState({
                outbound_plant_wise_transporter_configuration_options : outbound_plant_wise_transporter_configuration_options
            });
        }
        if(e.target.name == "outbound_route_preferences")
        {
            if(e.target.checked == true)
            {
               var outbound_route_preferences_options = "show-m";
            }
            else
            {
                var outbound_route_preferences_options = "show-n";
                $("#outbound_route_configuration").prop('checked', false);
                $("#outbound_auto_clustering").prop('checked', false);
                $("#outbound_plant_wise_configuration").prop('checked', false);
                $("#outbound_zone_wise_configuration").prop('checked', false);
                $("#outbound_transporter_wise_configuration").prop('checked', false);
                $("#outbound_cluster_based_on_proximite").prop('checked', false);
                $("#outbound_cluster_based_on_demands").prop('checked', false);
                $("#outbound_cluster_based_on_demand_distance_factor").prop('checked', false);
                this.setState({
                    outbound_route_configuration_type_options : "show-n",
                    outbound_auto_clustering_type_options : "show-n",
                });
            }
            this.setState({
                outbound_route_preferences_options : outbound_route_preferences_options
            });
        }
        if(e.target.name == "outbound_route_configuration")
        {
            var outbound_route_configuration_type_options = "show-n";
            var outbound_auto_clustering_type_options = "show-n";
            if(e.target.checked == true)
            {
                if(e.target.value == 1)
                {
                    var outbound_route_configuration_type_options = "show-m";
                }
                else
                {                    
                    $("#outbound_cluster_based_on_proximite").prop('checked', false);
                    $("#outbound_cluster_based_on_demands").prop('checked', false);
                    $("#outbound_cluster_based_on_demand_distance_factor").prop('checked', false);
                }
                if(e.target.value == 2)
                {
                    var outbound_auto_clustering_type_options = "show-m";
                }
                else
                {
                    $("#outbound_plant_wise_configuration").prop('checked', false);
                    $("#outbound_zone_wise_configuration").prop('checked', false);
                    $("#outbound_transporter_wise_configuration").prop('checked', false);
                }
            }
            else
            {
                $("#outbound_plant_wise_configuration").prop('checked', false);
                $("#outbound_zone_wise_configuration").prop('checked', false);
                $("#outbound_transporter_wise_configuration").prop('checked', false);
                $("#outbound_cluster_based_on_proximite").prop('checked', false);
                $("#outbound_cluster_based_on_demands").prop('checked', false);
                $("#outbound_cluster_based_on_demand_distance_factor").prop('checked', false);
            }
            this.setState({
                outbound_route_configuration_type_options : outbound_route_configuration_type_options,
                outbound_auto_clustering_type_options : outbound_auto_clustering_type_options,
            });
        }
    }
    saveInboundConfigs = () => {
        var module_type = 1;
        var data_type = 1;
        var pickup = 0;
        if ($("#inbound_pickup").prop('checked')==true){ 
            pickup = $("#inbound_pickup").val();
        }
        var pickup_time_windows = 0;
        if ($("#inbound_pickup_time_windows").prop('checked')==true){ 
            pickup_time_windows = $("#inbound_pickup_time_windows").val();
        }
        var drop = 0;
        if ($("#inbound_drop").prop('checked')==true){ 
            drop = $("#inbound_drop").val();
        }
        var drop_time_windows = 0;
        if ($("#inbound_drop_time_windows").prop('checked')==true){ 
            drop_time_windows = $("#inbound_drop_time_windows").val();
        }
        var vehicle_types = 0;
        if ($("#inbound_vehicle_types").prop('checked')==true){ 
            vehicle_types = $("#inbound_vehicle_types").val();
        }
        var max_no_of_trucks_check = 0;
        var max_no_of_trucks = 4;
        if ($("#max_no_of_trucks_check").prop('checked')==true){ 
            var max_no_of_trucks = $("#max_no_of_trucks_check").val();
        }
        var truck_min_max_configuration_preferences = 0;
        if ($("#inbound_truck_min_max_configuration_preferences").prop('checked')==true){ 
            truck_min_max_configuration_preferences = $("#inbound_truck_min_max_configuration_preferences").val();
        }
        var truck_weight_min_max_preferences = 0;
        if ($("#inbound_truck_weight_min_max_preferences").prop('checked')==true){ 
            truck_weight_min_max_preferences = $("#inbound_truck_weight_min_max_preferences").val();
        }
        var min_load_preferences = 0;
        if ($("#inbound_min_load_preferences").prop('checked')==true){ 
            min_load_preferences = $("#inbound_min_load_preferences").val();
        }
        var clubbing_limits = 0;
        if ($("#inbound_clubbing_limits").prop('checked')==true){ 
            clubbing_limits = $("#inbound_clubbing_limits").val();
        }
        var distance_preferences = 0;
        if ($("#inbound_distance_preferences").prop('checked')==true){ 
            distance_preferences = $("#inbound_distance_preferences").val();
        }
        var truck_priorities = 0;
        if ($("#inbound_truck_priorities").prop('checked')==true){ 
            truck_priorities = $("#inbound_truck_priorities").val();
        }
        var vehicle_operational_times = 0;
        var vehicle_operational_times_type = 0;
        if ($("#inbound_vehicle_operational_times").prop('checked')==true){ 
            vehicle_operational_times = $("#inbound_vehicle_operational_times").val();
            if ($("#inbound_generic_time_windows").prop('checked')==true){ 
                vehicle_operational_times_type = $("#inbound_generic_time_windows").val();
            }
            if ($("#inbound_individual_truck_time_windows").prop('checked')==true){ 
                vehicle_operational_times_type = $("#inbound_individual_truck_time_windows").val();
            }
        }
        var vehicle_availability = 0;
        var vehicle_availability_type = 0;
        if ($("#inbound_vehicle_availability").prop('checked')==true){ 
            vehicle_availability = $("#inbound_vehicle_availability").val();
            if ($("#inbound_vehicle_availability_by_vehicle_type").prop('checked')==true){ 
                vehicle_availability_type = $("#inbound_vehicle_availability_by_vehicle_type").val();
            }
            if ($("#inbound_vehicle_availability_by_individual_vehicle").prop('checked')==true){ 
                vehicle_availability_type = $("#inbound_vehicle_availability_by_individual_vehicle").val();
            }
        }
        var loading_unloading_sequencing = 0;
        if ($("#inbound_loading_unloading_sequencing").prop('checked')==true){ 
            loading_unloading_sequencing = $("#inbound_loading_unloading_sequencing").val();
        }
        var material_configuration = 0;
        if ($("#inbound_material_configuration").prop('checked')==true){ 
            material_configuration = $("#inbound_material_configuration").val();
        }
        var plant_wise_freight_configuration = 0;
        var plant_wise_freight_fixed_cost = 0;
        var plant_wise_freight_variable_cost = 0;
        var plant_wise_freight_vehicle_type_variable_cost = 0;
        var plant_wise_freight_city_level_vehicle_cost = 0;
        var per_cmt_cost = 0;
        var per_km_cost = 0;
        if ($("#inbound_plant_wise_freight_configuration").prop('checked')==true){ 
            plant_wise_freight_configuration = $("#inbound_plant_wise_freight_configuration").val();
            if ($("#inbound_plant_wise_freight_fixed_cost").prop('checked')==true){ 
                plant_wise_freight_fixed_cost = $("#inbound_plant_wise_freight_fixed_cost").val();
            }
            if ($("#inbound_plant_wise_freight_variable_cost").prop('checked')==true){ 
                plant_wise_freight_variable_cost = $("#inbound_plant_wise_freight_variable_cost").val();
                if ($("#inbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked')==true){ 
                    plant_wise_freight_vehicle_type_variable_cost = $("#inbound_plant_wise_freight_vehicle_type_variable_cost").val();
                }
                if ($("#inbound_plant_wise_freight_city_level_vehicle_cost").prop('checked')==true){ 
                    plant_wise_freight_city_level_vehicle_cost = $("#inbound_plant_wise_freight_city_level_vehicle_cost").val();
                    if ($("#inbound_per_cmt_cost").prop('checked')==true){ 
                        per_cmt_cost = $("#inbound_per_cmt_cost").val();
                    }
                    if ($("#inbound_per_km_cost").prop('checked')==true){ 
                        per_km_cost = $("#inbound_per_km_cost").val();
                    }
                }
            }
        }
        var plant_wise_transporter_configuration = 0;
        var transporter_share_of_business = 0;
        if ($("#inbound_plant_wise_transporter_configuration").prop('checked')==true){ 
            plant_wise_transporter_configuration = $("#inbound_plant_wise_transporter_configuration").val();
            if ($("#inbound_transporter_share_of_business").prop('checked')==true){ 
                transporter_share_of_business = $("#inbound_transporter_share_of_business").val();
            }
        }
        var route_preferences = 0;
        var route_configuration = 0;
        var auto_clustering = 0;
        var route_configuration_type = 0;
        var auto_clustering_type = 0;
        if ($("#inbound_route_preferences").prop('checked')==true){ 
            route_preferences = $("#inbound_route_preferences").val();
            if ($("#inbound_route_configuration").prop('checked')==true){ 
                route_configuration = $("#inbound_route_configuration").val();
                if ($("#inbound_plant_wise_configuration").prop('checked')==true){ 
                    route_configuration_type = $("#inbound_plant_wise_configuration").val();
                }
                if ($("#inbound_zone_wise_configuration").prop('checked')==true){ 
                    route_configuration_type = $("#inbound_zone_wise_configuration").val();
                }
                if ($("#inbound_transporter_wise_configuration").prop('checked')==true){ 
                    route_configuration_type = $("#inbound_transporter_wise_configuration").val();
                }
            }
            if ($("#inbound_auto_clustering").prop('checked')==true){ 
                auto_clustering = $("#inbound_auto_clustering").val();
                if ($("#inbound_cluster_based_on_proximite").prop('checked')==true){ 
                    auto_clustering_type = $("#inbound_cluster_based_on_proximite").val();
                }
                if ($("#inbound_cluster_based_on_demands").prop('checked')==true){ 
                    auto_clustering_type = $("#inbound_cluster_based_on_demands").val();
                }
                if ($("#inbound_cluster_based_on_demand_distance_factor").prop('checked')==true){ 
                    auto_clustering_type = $("#inbound_cluster_based_on_demand_distance_factor").val();
                }
            }
        }
        var plant_wise_new_plan_creation = 0;
        if ($("#inbound_plant_wise_new_plan_creation").prop('checked')==true){ 
            plant_wise_new_plan_creation = $("#inbound_plant_wise_new_plan_creation").val();
        }
        var plant_wise_plan_summary = 0;
        if ($("#inbound_plant_wise_plan_summary").prop('checked')==true){ 
            plant_wise_plan_summary = $("#inbound_plant_wise_plan_summary").val();
        }
        var plant_wise_planning_history = 0;
        if ($("#inbound_plant_wise_planning_history").prop('checked')==true){ 
            plant_wise_planning_history = $("#inbound_plant_wise_planning_history").val();
        }
        var params = {module_type:parseInt(module_type),data_type:parseInt(data_type),pickup:parseInt(pickup),pickup_time_windows:parseInt(pickup_time_windows),drop:parseInt(drop),drop_time_windows:parseInt(drop_time_windows),vehicle_types:parseInt(vehicle_types),max_no_of_trucks:parseInt(max_no_of_trucks),truck_min_max_configuration_preferences:parseInt(truck_min_max_configuration_preferences),truck_weight_min_max_preferences:parseInt(truck_weight_min_max_preferences),min_load_preferences:parseInt(min_load_preferences),clubbing_limits:parseInt(clubbing_limits),distance_preferences:parseInt(distance_preferences),truck_priorities:parseInt(truck_priorities),vehicle_operational_times:parseInt(vehicle_operational_times),vehicle_operational_times_type:parseInt(vehicle_operational_times_type),vehicle_availability:parseInt(vehicle_availability),vehicle_availability_type:parseInt(vehicle_availability_type),loading_unloading_sequencing:parseInt(loading_unloading_sequencing),material_configuration:parseInt(material_configuration),plant_wise_freight_configuration:parseInt(plant_wise_freight_configuration),plant_wise_freight_fixed_cost:parseInt(plant_wise_freight_fixed_cost),plant_wise_freight_variable_cost:parseInt(plant_wise_freight_variable_cost),plant_wise_freight_vehicle_type_variable_cost:parseInt(plant_wise_freight_vehicle_type_variable_cost),plant_wise_freight_city_level_vehicle_cost:parseInt(plant_wise_freight_city_level_vehicle_cost),per_cmt_cost:parseInt(per_cmt_cost),per_km_cost:parseInt(per_km_cost),plant_wise_transporter_configuration:parseInt(plant_wise_transporter_configuration),transporter_share_of_business:parseInt(transporter_share_of_business),route_preferences:parseInt(route_preferences),route_configuration:parseInt(route_configuration),auto_clustering:parseInt(auto_clustering),route_configuration_type:parseInt(route_configuration_type),auto_clustering_type:parseInt(auto_clustering_type),plant_wise_new_plan_creation:parseInt(plant_wise_new_plan_creation),plant_wise_plan_summary:parseInt(plant_wise_plan_summary),plant_wise_planning_history:parseInt(plant_wise_planning_history)}
        console.log(params,"params")
        redirectURL.post('master/saveappconfigurations',params)
        .then(response =>{
            
            if(response.data.status == 'success'){
                this.getConfigurations()
                this.setState({
                    show:true,
                    basicTitle:"Data Saved successfully",
                    basicType:"success"
                })
            }else{
                this.setState({
                    show:true,
                    basicTitle:"Data Not Saved successfully",
                    basicType:"danger"
                })
            }

        })
    }
    saveOutboundConfigs = () => {
        var module_type = 1;
        var data_type = 2;
        var pickup = 0;
        if ($("#outbound_pickup").prop('checked')==true){ 
            pickup = $("#outbound_pickup").val();
        }
        var pickup_time_windows = 0;
        if ($("#outbound_pickup_time_windows").prop('checked')==true){ 
            pickup_time_windows = $("#outbound_pickup_time_windows").val();
        }
        var drop = 0;
        if ($("#outbound_drop").prop('checked')==true){ 
            drop = $("#outbound_drop").val();
        }
        var drop_time_windows = 0;
        if ($("#outbound_drop_time_windows").prop('checked')==true){ 
            drop_time_windows = $("#outbound_drop_time_windows").val();
        }
        var vehicle_types = 0;
        if ($("#outbound_vehicle_types").prop('checked')==true){ 
            vehicle_types = $("#outbound_vehicle_types").val();
        }
        var max_no_of_trucks_check = 0;
        var max_no_of_trucks = 4;
        if ($("#max_no_of_trucks_check").prop('checked')==true){ 
            var max_no_of_trucks = $("#max_no_of_trucks_check").val();
        }
        var truck_min_max_configuration_preferences = 0;
        if ($("#outbound_truck_min_max_configuration_preferences").prop('checked')==true){ 
            truck_min_max_configuration_preferences = $("#outbound_truck_min_max_configuration_preferences").val();
        }
        var truck_weight_min_max_preferences = 0;
        if ($("#outbound_truck_weight_min_max_preferences").prop('checked')==true){ 
            truck_weight_min_max_preferences = $("#outbound_truck_weight_min_max_preferences").val();
        }
        var min_load_preferences = 0;
        if ($("#outbound_min_load_preferences").prop('checked')==true){ 
            min_load_preferences = $("#outbound_min_load_preferences").val();
        }
        var clubbing_limits = 0;
        if ($("#outbound_clubbing_limits").prop('checked')==true){ 
            clubbing_limits = $("#outbound_clubbing_limits").val();
        }
        var distance_preferences = 0;
        if ($("#outbound_distance_preferences").prop('checked')==true){ 
            distance_preferences = $("#outbound_distance_preferences").val();
        }
        var truck_priorities = 0;
        if ($("#outbound_truck_priorities").prop('checked')==true){ 
            truck_priorities = $("#outbound_truck_priorities").val();
        }
        var vehicle_operational_times = 0;
        var vehicle_operational_times_type = 0;
        if ($("#outbound_vehicle_operational_times").prop('checked')==true){ 
            vehicle_operational_times = $("#outbound_vehicle_operational_times").val();
            if ($("#outbound_generic_time_windows").prop('checked')==true){ 
                vehicle_operational_times_type = $("#outbound_generic_time_windows").val();
            }
            if ($("#outbound_individual_truck_time_windows").prop('checked')==true){ 
                vehicle_operational_times_type = $("#outbound_individual_truck_time_windows").val();
            }
        }
        var vehicle_availability = 0;
        var vehicle_availability_type = 0;
        if ($("#outbound_vehicle_availability").prop('checked')==true){ 
            vehicle_availability = $("#outbound_vehicle_availability").val();
            if ($("#outbound_vehicle_availability_by_vehicle_type").prop('checked')==true){ 
                vehicle_availability_type = $("#outbound_vehicle_availability_by_vehicle_type").val();
            }
            if ($("#outbound_vehicle_availability_by_individual_vehicle").prop('checked')==true){ 
                vehicle_availability_type = $("#outbound_vehicle_availability_by_individual_vehicle").val();
            }
        }
        var loading_unloading_sequencing = 0;
        if ($("#outbound_loading_unloading_sequencing").prop('checked')==true){ 
            loading_unloading_sequencing = $("#outbound_loading_unloading_sequencing").val();
        }
        var material_configuration = 0;
        if ($("#outbound_material_configuration").prop('checked')==true){ 
            material_configuration = $("#outbound_material_configuration").val();
        }
        var plant_wise_freight_configuration = 0;
        var plant_wise_freight_fixed_cost = 0;
        var plant_wise_freight_variable_cost = 0;
        var plant_wise_freight_vehicle_type_variable_cost = 0;
        var plant_wise_freight_city_level_vehicle_cost = 0;
        var per_cmt_cost = 0;
        var per_km_cost = 0;
        if ($("#outbound_plant_wise_freight_configuration").prop('checked')==true){ 
            plant_wise_freight_configuration = $("#outbound_plant_wise_freight_configuration").val();
            if ($("#outbound_plant_wise_freight_fixed_cost").prop('checked')==true){ 
                plant_wise_freight_fixed_cost = $("#outbound_plant_wise_freight_fixed_cost").val();
            }
            if ($("#outbound_plant_wise_freight_variable_cost").prop('checked')==true){ 
                plant_wise_freight_variable_cost = $("#outbound_plant_wise_freight_variable_cost").val();
                if ($("#outbound_plant_wise_freight_vehicle_type_variable_cost").prop('checked')==true){ 
                    plant_wise_freight_vehicle_type_variable_cost = $("#outbound_plant_wise_freight_vehicle_type_variable_cost").val();
                }
                if ($("#outbound_plant_wise_freight_city_level_vehicle_cost").prop('checked')==true){ 
                    plant_wise_freight_city_level_vehicle_cost = $("#outbound_plant_wise_freight_city_level_vehicle_cost").val();
                    if ($("#outbound_per_cmt_cost").prop('checked')==true){ 
                        per_cmt_cost = $("#outbound_per_cmt_cost").val();
                    }
                    if ($("#outbound_per_km_cost").prop('checked')==true){ 
                        per_km_cost = $("#outbound_per_km_cost").val();
                    }
                }
            }
        }
        var plant_wise_transporter_configuration = 0;
        var transporter_share_of_business = 0;
        if ($("#outbound_plant_wise_transporter_configuration").prop('checked')==true){ 
            plant_wise_transporter_configuration = $("#outbound_plant_wise_transporter_configuration").val();
            if ($("#outbound_transporter_share_of_business").prop('checked')==true){ 
                transporter_share_of_business = $("#outbound_transporter_share_of_business").val();
            }
        }
        var route_preferences = 0;
        var route_configuration = 0;
        var auto_clustering = 0;
        var route_configuration_type = 0;
        var auto_clustering_type = 0;
        if ($("#outbound_route_preferences").prop('checked')==true){ 
            route_preferences = $("#outbound_route_preferences").val();
            if ($("#outbound_route_configuration").prop('checked')==true){ 
                route_configuration = $("#outbound_route_configuration").val();
                if ($("#outbound_plant_wise_configuration").prop('checked')==true){ 
                    route_configuration_type = $("#outbound_plant_wise_configuration").val();
                }
                if ($("#outbound_zone_wise_configuration").prop('checked')==true){ 
                    route_configuration_type = $("#outbound_zone_wise_configuration").val();
                }
                if ($("#outbound_transporter_wise_configuration").prop('checked')==true){ 
                    route_configuration_type = $("#outbound_transporter_wise_configuration").val();
                }
            }
            if ($("#outbound_auto_clustering").prop('checked')==true){ 
                auto_clustering = $("#outbound_auto_clustering").val();
                if ($("#outbound_cluster_based_on_proximite").prop('checked')==true){ 
                    auto_clustering_type = $("#outbound_cluster_based_on_proximite").val();
                }
                if ($("#outbound_cluster_based_on_demands").prop('checked')==true){ 
                    auto_clustering_type = $("#outbound_cluster_based_on_demands").val();
                }
                if ($("#outbound_cluster_based_on_demand_distance_factor").prop('checked')==true){ 
                    auto_clustering_type = $("#outbound_cluster_based_on_demand_distance_factor").val();
                }
            }
        }
        var plant_wise_new_plan_creation = 0;
        if ($("#outbound_plant_wise_new_plan_creation").prop('checked')==true){ 
            plant_wise_new_plan_creation = $("#outbound_plant_wise_new_plan_creation").val();
        }
        var plant_wise_plan_summary = 0;
        if ($("#outbound_plant_wise_plan_summary").prop('checked')==true){ 
            plant_wise_plan_summary = $("#outbound_plant_wise_plan_summary").val();
        }
        var plant_wise_planning_history = 0;
        if ($("#outbound_plant_wise_planning_history").prop('checked')==true){ 
            plant_wise_planning_history = $("#outbound_plant_wise_planning_history").val();
        }
        var params = {module_type:parseInt(module_type),data_type:parseInt(data_type),pickup:parseInt(pickup),pickup_time_windows:parseInt(pickup_time_windows),drop:parseInt(drop),drop_time_windows:parseInt(drop_time_windows),vehicle_types:parseInt(vehicle_types),max_no_of_trucks:parseInt(max_no_of_trucks),truck_min_max_configuration_preferences:parseInt(truck_min_max_configuration_preferences),truck_weight_min_max_preferences:parseInt(truck_weight_min_max_preferences),min_load_preferences:parseInt(min_load_preferences),clubbing_limits:parseInt(clubbing_limits),distance_preferences:parseInt(distance_preferences),truck_priorities:parseInt(truck_priorities),vehicle_operational_times:parseInt(vehicle_operational_times),vehicle_operational_times_type:parseInt(vehicle_operational_times_type),vehicle_availability:parseInt(vehicle_availability),vehicle_availability_type:parseInt(vehicle_availability_type),loading_unloading_sequencing:parseInt(loading_unloading_sequencing),material_configuration:parseInt(material_configuration),plant_wise_freight_configuration:parseInt(plant_wise_freight_configuration),plant_wise_freight_fixed_cost:parseInt(plant_wise_freight_fixed_cost),plant_wise_freight_variable_cost:parseInt(plant_wise_freight_variable_cost),plant_wise_freight_vehicle_type_variable_cost:parseInt(plant_wise_freight_vehicle_type_variable_cost),plant_wise_freight_city_level_vehicle_cost:parseInt(plant_wise_freight_city_level_vehicle_cost),per_cmt_cost:parseInt(per_cmt_cost),per_km_cost:parseInt(per_km_cost),plant_wise_transporter_configuration:parseInt(plant_wise_transporter_configuration),transporter_share_of_business:parseInt(transporter_share_of_business),route_preferences:parseInt(route_preferences),route_configuration:parseInt(route_configuration),auto_clustering:parseInt(auto_clustering),route_configuration_type:parseInt(route_configuration_type),auto_clustering_type:parseInt(auto_clustering_type),plant_wise_new_plan_creation:parseInt(plant_wise_new_plan_creation),plant_wise_plan_summary:parseInt(plant_wise_plan_summary),plant_wise_planning_history:parseInt(plant_wise_planning_history)}
        console.log(params,"params")
        redirectURL.post('master/saveappconfigurations',params)
        .then(response =>{
            
            if(response.data.status == 'success'){
                this.getConfigurations()
                this.setState({
                    show:true,
                    basicTitle:"Data Saved successfully",
                    basicType:"success"
                })
            }else{
                this.setState({
                    show:true,
                    basicTitle:"Data Not Saved successfully",
                    basicType:"danger"
                })
            }

        })
    }
    closeAlert = () => {
        this.setState({
            show: false
        });
        window.location.reload();
    }
    render(){
        return(
            <div className="">
            <SweetAlert
                show={this.state.show}
                type={this.state.basicType}
                title={this.state.basicTitle}
                onConfirm={this.closeAlert}>
            </SweetAlert>                
                <div className="row mb-20p pt-20p">
                    <div className="col-sm-12 d-flex">
                        <div className= {this.state.showAvailablityTable ? "col-sm-7 " : "col-sm-12 " + "  d-inline"}>
                            <h5 className='fbold  d-flex justify-content-between'>
                                <span>Configurations</span>
                            </h5>
                        </div>
                    </div>
                </div>               
                <div className="row mb-20p">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body" style={{minHeight:"90vh"}}>
                                <ul className="d-tabs">
                                    {(this.state.dispatchShow == 1)?
                                    <li onClick={this.onClickTab.bind(this,"dispatch")} className={"lttabs "+(this.state.dispatch)}>
                                        <button type="button" className="btn">Dispatch Planning</button>
                                    </li>
                                    :""}
                                    {(this.state.stackShow == 1)?
                                    <li onClick={this.onClickTab.bind(this,"stacking")} className={"lttabs "+(this.state.stacking)}>
                                        <button type="button" className="btn">Stacking</button>
                                    </li>
                                    :""}
                                    {(this.state.productionPlanningShow == 1)?
                                    <li onClick={this.onClickTab.bind(this,"production")} className={"lttabs "+(this.state.production)}>
                                        <button type="button" className="btn">Production Planning</button>
                                    </li>
                                    :""}
                                    {(this.state.forecastingShow == 1)?
                                    <li onClick={this.onClickTab.bind(this,"forecasting")} className={" "+(this.state.forecasting)}>
                                        {/* <button type="button" className="btn">Forecasting</button> */}
                                    </li>
                                    :""}
                                    {(this.state.resourceSchedulingShow == 1)?
                                    <li onClick={this.onClickTab.bind(this,"resource")} className={"lttabs "+(this.state.resource)}>
                                        <button type="button" className="btn">Resource Scheduling</button>
                                    </li>
                                    :""}
                                </ul>
                                <div className={this.state.dispatchData}>     
                                    <div class={"row col-sm-12 mt-30p"}>
                                        <div className="col-sm-4">
                                            <label className="fw-800 mt-20per theme-clr">Enable/Disable Dispatch Planning Module</label>
                                        </div>
                                        <div className="col-sm-2">
                                            <Switch
                                                checked={this.state.dispatchChecked}
                                                onChange={this.handleDispatchChange}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                onColor="#20749b"
                                                onHandleColor="#d3dbdf"
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </div>
                                    </div>
                                    <div class={"row col-sm-12 mt-20p "+this.state.dispatchConfigs}>
                                        <div className="col-sm-6 brd-right">
                                            <div class={"row mt-20p"}>
                                                <div className="col-sm-7 txt-center">
                                                    <h5>Inbound </h5>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label htmlFor="material-switch">
                                                        <span style={{"marginRight":"10px"}}>Enable/Disable</span>
                                                        <Switch
                                                            checked={this.state.dispatchInboundChecked}
                                                            onChange={this.handleDispatchInboundChange}
                                                            onColor="#86d3ff"
                                                            onHandleColor="#2693e6"
                                                            handleDiameter={15}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={10}
                                                            width={28}
                                                            className="react-switch"
                                                            id="material-switch"
                                                        />                                                    
                                                    </label>
                                                </div>
                                            </div>
                                            <div class={this.state.dispatchConfigsInbound}>
                                                <div className="row mt-30p">
                                                    <label className="fw-600"><input name="inbound_pickup" id="inbound_pickup" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Suppliers / Vendor Locations (Pickup)*</label>
                                                </div>
                                                <div className="row ml-3per">
                                                    <label className="fw-600"><input name="inbound_pickup_time_windows" id="inbound_pickup_time_windows" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Operational Hours</label>
                                                </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_drop" id="inbound_drop" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant / Warehouse Locations (Drop)*</label>
                                                </div>
                                                <div className="row ml-3per">
                                                    <label className="fw-600"><input name="inbound_drop_time_windows" id="inbound_drop_time_windows" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Operational Hours</label>
                                                </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_vehicle_types" id="inbound_vehicle_types" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise Vehicle Type Configuration*</label>
                                                </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_max_no_of_trucks_check" id="inbound_max_no_of_trucks_check" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Max No. Of Vehicle Types&nbsp;&nbsp;<input name="inbound_max_no_of_trucks" className="num-cls" id="inbound_max_no_of_trucks" value="4" type="text" disabled style={{width:"40px"}}/></label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_truck_min_max_configuration_preferences" id="inbound_truck_min_max_configuration_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Load Capacity Min / Max Configuration Preferences</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_truck_weight_min_max_preferences" id="inbound_truck_weight_min_max_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Weight Min / Max Preferences</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_min_load_preferences" id="inbound_min_load_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Min Load Preferences from Suppliers / Vendor</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_clubbing_limits" id="inbound_clubbing_limits" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Suppliers / Vendor Clubbing Limits</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_distance_preferences" id="inbound_distance_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Distance preferences</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_truck_priorities" id="inbound_truck_priorities" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Priorities</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_vehicle_operational_times" id="inbound_vehicle_operational_times" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Operational Times</label>
                                                    </div>
                                                        <div className={"row ml-6per "+this.state.inbound_vehicle_operational_times_options}>
                                                            <label className="fw-600"><input name="inbound_vehicle_operational_times_type" id="inbound_generic_time_windows" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Generic Time Windows</label> &nbsp;&nbsp;
                                                            <label className="fw-600"><input name="inbound_vehicle_operational_times_type" id="inbound_individual_truck_time_windows" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Individual Vehicle Time Windows</label>
                                                        </div>
                                                    
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_vehicle_availability" id="inbound_vehicle_availability" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Availability</label>
                                                    </div>
                                                        <div className={"row ml-6per "+this.state.inbound_vehicle_availability_options}>
                                                            <label className="fw-600"><input name="inbound_vehicle_availability_type" id="inbound_vehicle_availability_by_vehicle_type" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Availability By Vehicle Type</label> &nbsp;&nbsp;
                                                            <label className="fw-600"><input name="inbound_vehicle_availability_type" id="inbound_vehicle_availability_by_individual_vehicle" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Availability By Individual Vehicle</label>
                                                        </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="inbound_loading_unloading_sequencing" id="inbound_loading_unloading_sequencing" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Loading & Unloading Sequencing</label>
                                                    </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_material_configuration" id="inbound_material_configuration" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Material Configuration</label>
                                                </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_plant_wise_freight_configuration" id="inbound_plant_wise_freight_configuration" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Plant Wise Freight Configuration</label>
                                                </div>
                                                    <div className={"row ml-3per "+this.state.inbound_plant_wise_freight_configuration_options}>
                                                        <label className="fw-600"><input name="inbound_plant_wise_freight_fixed_cost" id="inbound_plant_wise_freight_fixed_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Fixed Vehicle Costs</label> &nbsp;&nbsp;
                                                        <label className="fw-600"><input name="inbound_plant_wise_freight_variable_cost" id="inbound_plant_wise_freight_variable_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Variable Costs</label>
                                                    </div>
                                                        <div className={"row ml-6per "+this.state.inbound_plant_wise_freight_variable_cost_options}>
                                                            <label className="fw-600"><input name="inbound_plant_wise_freight_vehicle_type_variable_cost" id="inbound_plant_wise_freight_vehicle_type_variable_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Vehicle Type Level Variable Costs</label> &nbsp;&nbsp;
                                                            <label className="fw-600"><input name="inbound_plant_wise_freight_city_level_vehicle_cost" id="inbound_plant_wise_freight_city_level_vehicle_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;City Level Vehicle Type Costs</label>
                                                        </div> 
                                                            <div className={"row ml-9per "+this.state.inbound_plant_wise_freight_city_level_vehicle_cost_options}>
                                                                <label className="fw-600"><input name="inbound_plant_wise_freight_city_level_vehicle_cost_type" id="inbound_per_cmt_cost" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Per CMT Cost</label> &nbsp;&nbsp;
                                                                <label className="fw-600"><input name="inbound_plant_wise_freight_city_level_vehicle_cost_type" id="inbound_per_km_cost" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Per KM Cost</label>
                                                            </div>  
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_plant_wise_transporter_configuration" id="inbound_plant_wise_transporter_configuration" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Plant Wise Transporter Configuration</label>
                                                </div>
                                                    <div className={"row ml-3per "+this.state.inbound_plant_wise_transporter_configuration_options}>
                                                        <label className="fw-600"><input name="inbound_transporter_share_of_business" id="inbound_transporter_share_of_business" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Transporter Share of Business</label>
                                                    </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_route_preferences" id="inbound_route_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Route Preferences</label>
                                                </div>
                                                    <div className={"row ml-3per "+this.state.inbound_route_preferences_options}>
                                                        <label className="fw-600"><input name="inbound_route_configuration" id="inbound_route_configuration" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Route Configuration</label> &nbsp;&nbsp;
                                                        <label className="fw-600"><input name="inbound_route_configuration" id="inbound_auto_clustering" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Auto Clustering</label>
                                                    </div>
                                                        <div className={"row ml-9per "+this.state.inbound_route_configuration_type_options}>
                                                            <label className="fw-600"><input name="inbound_route_configuration_type" id="inbound_plant_wise_configuration" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Plant wise configuration</label> <br></br>
                                                            <label className="fw-600"><input name="inbound_route_configuration_type" id="inbound_zone_wise_configuration" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Zone wise configuration</label><br></br>
                                                            <label className="fw-600"><input name="inbound_route_configuration_type" id="inbound_transporter_wise_configuration" value="3" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Transporter wise configuration</label>
                                                        </div>
                                                        <div className={"row ml-9per "+this.state.inbound_auto_clustering_type_options}>
                                                            <label className="fw-600"><input name="inbound_auto_clustering_type" id="inbound_cluster_based_on_proximite" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Cluster based on Supplier / Vendor Proximities</label> &nbsp;&nbsp;
                                                            <label className="fw-600"><input name="inbound_auto_clustering_type" id="inbound_cluster_based_on_demands" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Cluster based on Supplier / Vendor Demands</label>
                                                            <label className="fw-600"><input name="inbound_auto_clustering_type" id="inbound_cluster_based_on_demand_distance_factor" value="3" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Cluster based on weighted demand x distance factor</label>
                                                        </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_plant_wise_new_plan_creation" id="inbound_plant_wise_new_plan_creation" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise New Plan Creation*</label>
                                                </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_plant_wise_plan_summary" id="inbound_plant_wise_plan_summary" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise Plan Summary*</label>
                                                </div>
                                                <div className="row">
                                                    <label className="fw-600"><input name="inbound_plant_wise_planning_history" id="inbound_plant_wise_planning_history" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise Planning History*</label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <button type="button" className="btn btn-warning float-right" onClick={this.saveInboundConfigs}>Save Inbound Configurations</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div class={"row mt-20p"}>
                                                <div className="col-sm-7 txt-center">
                                                    <h5>Outbound </h5>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label htmlFor="material-switch">
                                                        <span style={{"marginRight":"10px"}}>Enable/Disable</span>
                                                        <Switch
                                                            checked={this.state.dispatchOutboundChecked}
                                                            onChange={this.handleDispatchOutboundChange}
                                                            onColor="#86d3ff"
                                                            onHandleColor="#2693e6"
                                                            handleDiameter={15}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={10}
                                                            width={28}
                                                            className="react-switch"
                                                            id="material-switch"
                                                        />                                                    
                                                    </label>
                                                </div>
                                            </div>
                                            <div class={"col-sm-12 "+this.state.dispatchConfigsOutbound}>
                                                <div className="row mt-30p">
                                                        <label className="fw-600"><input name="outbound_pickup" id="outbound_pickup" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant / Warehouse Locations (Pickup)*</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="outbound_pickup_time_windows" id="outbound_pickup_time_windows" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Operational Hours</label>
                                                            {/* <div className="show-config-info">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-info-circle f16"></i>
                                                            </div>
                                                            <div className="hide">&nbsp;&nbsp;HI</div>          */}
                                                    </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_drop" id="outbound_drop" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Consignees / Dealers Locations (Drop)*</label>
                                                    </div>
                                                    <div className="row ml-3per">
                                                        <label className="fw-600"><input name="outbound_drop_time_windows" id="outbound_drop_time_windows" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Operational Hours</label>
                                                        {/* <div className="show-config-info">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-info-circle f16"></i>
                                                        </div>
                                                        <div className="hide">&nbsp;&nbsp;HI</div>  */}
                                                    </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_vehicle_types" id="outbound_vehicle_types" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise Vehicle Type Configuration*</label>
                                                    </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_max_no_of_trucks_check" id="outbound_max_no_of_trucks_check" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Max No. Of Vehicle Types&nbsp;&nbsp;<input name="outbound_max_no_of_trucks" className="num-cls" id="outbound_max_no_of_trucks" value="4" type="text" disabled style={{width:"40px"}}/></label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_truck_min_max_configuration_preferences" id="outbound_truck_min_max_configuration_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Load Capacity Min / Max Configuration Preferences</label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                        <label className="fw-600"><input name="outbound_truck_weight_min_max_preferences" id="outbound_truck_weight_min_max_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Weight Min / Max Preferences</label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_min_load_preferences" id="outbound_min_load_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Min Load Preferences from Consignees / Dealers</label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_clubbing_limits" id="outbound_clubbing_limits" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Consignees / Dealers Clubbing Limits</label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_distance_preferences" id="outbound_distance_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Distance preferences</label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_truck_priorities" id="outbound_truck_priorities" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Priorities</label>
                                                        </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_vehicle_operational_times" id="outbound_vehicle_operational_times" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Operational Times</label>
                                                        </div>
                                                            <div className={"row ml-6per "+this.state.outbound_vehicle_operational_times_options}>
                                                                <label className="fw-600"><input name="outbound_vehicle_operational_times_type" id="outbound_generic_time_windows" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Generic Time Windows</label> &nbsp;&nbsp;
                                                                <label className="fw-600"><input name="outbound_vehicle_operational_times_type" id="outbound_individual_truck_time_windows" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Individual Vehicle Time Windows</label>
                                                            </div>
                                                        
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_vehicle_availability" id="outbound_vehicle_availability" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Vehicle Availability</label>
                                                        </div>
                                                            <div className={"row ml-6per "+this.state.outbound_vehicle_availability_options}>
                                                                <label className="fw-600"><input name="outbound_vehicle_availability_type" id="outbound_vehicle_availability_by_vehicle_type" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Availability By Vehicle Type</label> &nbsp;&nbsp;
                                                                <label className="fw-600"><input name="outbound_vehicle_availability_type" id="outbound_vehicle_availability_by_individual_vehicle" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Availability By Individual Vehicle</label>
                                                            </div>
                                                        <div className="row ml-3per">
                                                            <label className="fw-600"><input name="outbound_loading_unloading_sequencing" id="outbound_loading_unloading_sequencing" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Loading & Unloading Sequencing</label>
                                                        </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_material_configuration" id="outbound_material_configuration" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Material Configuration</label>
                                                    </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_plant_wise_freight_configuration" id="outbound_plant_wise_freight_configuration" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Plant Wise Freight Configuration</label>
                                                    </div>
                                                        <div className={"row ml-3per "+this.state.outbound_plant_wise_freight_configuration_options}>
                                                            <label className="fw-600"><input name="outbound_plant_wise_freight_fixed_cost" id="outbound_plant_wise_freight_fixed_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Fixed Vehicle Costs</label> &nbsp;&nbsp;
                                                            <label className="fw-600"><input name="outbound_plant_wise_freight_variable_cost" id="outbound_plant_wise_freight_variable_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Variable Costs</label>
                                                        </div>
                                                            <div className={"row ml-6per "+this.state.outbound_plant_wise_freight_variable_cost_options}>
                                                                <label className="fw-600"><input name="outbound_plant_wise_freight_vehicle_type_variable_cost" id="outbound_plant_wise_freight_vehicle_type_variable_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Vehicle Type Level Variable Costs</label> &nbsp;&nbsp;
                                                                <label className="fw-600"><input name="outbound_plant_wise_freight_city_level_vehicle_cost" id="outbound_plant_wise_freight_city_level_vehicle_cost" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;City Level Vehicle Type Costs</label>
                                                            </div> 
                                                                <div className={"row ml-9per "+this.state.outbound_plant_wise_freight_city_level_vehicle_cost_options}>
                                                                    <label className="fw-600"><input name="outbound_plant_wise_freight_city_level_vehicle_cost_type" id="outbound_per_cmt_cost" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Per CMT Cost</label> &nbsp;&nbsp;
                                                                    <label className="fw-600"><input name="outbound_plant_wise_freight_city_level_vehicle_cost_type" id="outbound_per_km_cost" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Per KM Cost</label>
                                                                </div>  
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_plant_wise_transporter_configuration" id="outbound_plant_wise_transporter_configuration" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Plant Wise Transporter Configuration</label>
                                                    </div>
                                                        <div className={"row ml-3per "+this.state.outbound_plant_wise_transporter_configuration_options}>
                                                            <label className="fw-600"><input name="outbound_transporter_share_of_business" id="outbound_transporter_share_of_business" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Transporter Share of Business</label>
                                                        </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_route_preferences" id="outbound_route_preferences" value="1" type="checkbox" onChange={this.changeHandler.bind(this)} />&nbsp;&nbsp;Route Preferences</label>
                                                    </div>
                                                        <div className={"row ml-3per "+this.state.outbound_route_preferences_options}>
                                                            <label className="fw-600"><input name="outbound_route_configuration" id="outbound_route_configuration" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Route Configuration</label> &nbsp;&nbsp;
                                                            <label className="fw-600"><input name="outbound_route_configuration" id="outbound_auto_clustering" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Auto Clustering</label>
                                                        </div>
                                                            <div className={"row ml-9per "+this.state.outbound_route_configuration_type_options}>
                                                                <label className="fw-600"><input name="outbound_route_configuration_type" id="outbound_plant_wise_configuration" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Plant wise configuration</label> <br></br>
                                                                <label className="fw-600"><input name="outbound_route_configuration_type" id="outbound_zone_wise_configuration" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Zone wise configuration</label><br></br>
                                                                <label className="fw-600"><input name="outbound_route_configuration_type" id="outbound_transporter_wise_configuration" value="3" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Transporter wise configuration</label>
                                                            </div>
                                                            <div className={"row ml-9per "+this.state.outbound_auto_clustering_type_options}>
                                                                <label className="fw-600"><input name="outbound_auto_clustering_type" id="outbound_cluster_based_on_proximite" value="1" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Cluster based on Supplier / Vendor Proximities</label> &nbsp;&nbsp;
                                                                <label className="fw-600"><input name="outbound_auto_clustering_type" id="outbound_cluster_based_on_demands" value="2" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Cluster based on Supplier / Vendor Demands</label>
                                                                <label className="fw-600"><input name="outbound_auto_clustering_type" id="outbound_cluster_based_on_demand_distance_factor" value="3" type="radio" onChange={this.changeHandler.bind(this)}  />&nbsp;&nbsp;Cluster based on weighted demand x distance factor</label>
                                                            </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_plant_wise_new_plan_creation" id="outbound_plant_wise_new_plan_creation" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise New Plan Creation*</label>
                                                    </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_plant_wise_plan_summary" id="outbound_plant_wise_plan_summary" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise Plan Summary*</label>
                                                    </div>
                                                    <div className="row">
                                                        <label className="fw-600"><input name="outbound_plant_wise_planning_history" id="outbound_plant_wise_planning_history" value="1" type="checkbox" onChange={this.changeHandler.bind(this)}  checked disabled/>&nbsp;&nbsp;Plant Wise Planning History*</label>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <button type="button" className="btn btn-danger float-right" onClick={this.saveOutboundConfigs}>Save Outbound Configurations</button>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={this.state.stackingData}>
                                <StackingConfiguration/>
                                </div>
                                <div className={this.state.forecastingData}>
                                <ForecastingConfiguration/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
$(document).on("input", ".num-cls", function() {
    this.value = this.value.replace(/\D/g,'');
});